import { useRef, useState } from "react";
import type { ComponentProps } from "react";
import { Button } from "@/components/ui/button";
import { AccessRequestModal } from "@/components/access-request-modal";

type AccessRequestButtonProps = ComponentProps<typeof Button> & {
  modalLabel?: string;
};

export function AccessRequestButton({
  children = "Request access",
  modalLabel,
  onClick,
  ...props
}: AccessRequestButtonProps) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        ref={triggerRef}
        type="button"
        onClick={(event) => {
          onClick?.(event);
          if (!event.defaultPrevented) setOpen(true);
        }}
        aria-haspopup="dialog"
        aria-label={modalLabel}
        {...props}
      >
        {children}
      </Button>
      <AccessRequestModal
        open={open}
        onOpenChange={setOpen}
        triggerRef={triggerRef}
      />
    </>
  );
}
